import actionTypes from "./actionTypes";
import * as ziadostUtils from "../utils/ziadostUtils";
import * as filesUtils from "../utils/filesUtils";

export const ulozData = (data) => {
  return async (dispatch) => {
    dispatch({
      type: actionTypes.ZIADOST_SAVE_DATA,
      data,
    });
  };
};
export const changeZiadost = (ziadost) => {
  return async (dispatch) => {
    dispatch({
      type: actionTypes.CHANGE_ZIADOST,
      data: ziadost,
    });
  };
};

const podatZiadostRequest = () => ({
  type: actionTypes.CREATE_ZIADOST_REQUEST,
});
const podatZiadostSuccess = (res) => ({
  type: actionTypes.CREATE_ZIADOST_SUCCESS,
  res,
});
const podatZiadostFailure = (error) => ({
  type: actionTypes.CREATE_ZIADOST_FAILURE,
  error,
});
export const podatZiadost = (ziadost, mapaImage, fileNames, files = []) => {
  return async (dispatch) => {
    try {
      dispatch(podatZiadostRequest());
      const res = await ziadostUtils.podatZiadost(ziadost, mapaImage);
      const I_AG_ZIADOST = res.Data;

      for (let i = 0; i < files.length; i++) {
        await filesUtils.uploadPrilohaZiadost(
          I_AG_ZIADOST,
          fileNames[i],
          files[i]
        );
      }
      dispatch(podatZiadostSuccess(res));
    } catch (error) {
      dispatch(podatZiadostFailure(error));
    }
  };
};

const getMyListZiadostRequest = () => ({
  type: actionTypes.GET_MY_LIST_ZIADOST_REQUEST,
});
const getMyListZiadostSuccess = (res) => ({
  type: actionTypes.GET_MY_LIST_ZIADOST_SUCCESS,
  res,
});
const getMyListZiadostFailure = (error) => ({
  type: actionTypes.GET_MY_LIST_ZIADOST_FAILURE,
  error,
});
export const getMyListZiadost = (filter, sort, page) => {
  return async (dispatch) => {
    try {
      dispatch(getMyListZiadostRequest());
      let res = await ziadostUtils.getMyListZiadost(filter, sort, page);
      dispatch(getMyListZiadostSuccess(res));
    } catch (error) {
      dispatch(getMyListZiadostFailure(error));
    }
  };
};

const getAllListZiadostRequest = () => ({
  type: actionTypes.GET_ALL_LIST_ZIADOST_REQUEST,
});
const getAllListZiadostSuccess = (res) => ({
  type: actionTypes.GET_ALL_LIST_ZIADOST_SUCCESS,
  res,
});
const getAllListZiadostFailure = (error) => ({
  type: actionTypes.GET_ALL_LIST_ZIADOST_FAILURE,
  error,
});
export const getAllListZiadost = (filter, sort, page) => {
  return async (dispatch) => {
    try {
      dispatch(getAllListZiadostRequest());
      let res = await ziadostUtils.getAllListZiadost(filter, sort, page);
      dispatch(getAllListZiadostSuccess(res));
    } catch (error) {
      dispatch(getAllListZiadostFailure(error));
    }
  };
};
